<script>
  export let open = false;
  export let display = true;
  export let left = true;
</script>

<article class:display class:open class:left>
  <div class:open on:click|stopPropagation={() => (open = !open)}>
    <svg width="32" height="24">
      <line id="top" x1="0" y1="2" x2="24" y2="2" />
      <line id="middle" x1="0" y1="12" x2="24" y2="12" />
      <line id="bottom" x1="0" y1="22" x2="24" y2="22" />
    </svg>
  </div>
  <nav class:open>
    <slot />
  </nav>
</article>

<style>
  article {
    position: relative;
    display: flex;
    visibility: hidden;
    flex-direction: column;
    transition: transform 0.3s ease-in-out;
    padding-left: 0.5em;
    /* align-self: stretch; */
    z-index: 20;
  }
  article.display {
    visibility: visible;
  }
  article.open {
    background-color: #f7f7f7;
    border-radius: 15px;
    z-index: 30;
  }

  div {
    cursor: pointer;
    z-index: 20;
    align-self: flex-start;
    justify-self: center;
    color: var(--primary-light-color);
    display: flex;
    align-items: center;
    height: 100%;
    margin-bottom: 5px;
  }

  div.open {
    line-height: 1em;
    align-self: flex-end;
  }

  article.left div.open {
    align-self: flex-start;
  }

  svg {
    min-height: 24px;
    transition: transform 0.3s ease-in-out;
  }

  svg line {
    stroke: currentColor;
    stroke-width: 3;
    transition: transform 0.3s ease-in-out;
  }

  div.open svg {
    transform: scale(0.7);
  }

  div.open #top {
    transform: translate(3px, 3px) rotate(45deg);
  }

  div.open #middle {
    opacity: 0;
  }

  div.open #bottom {
    transform: translate(-13px, 6px) rotate(-45deg);
  }

  nav {
    position: absolute;
    display: none;
    line-height: 1em;
    top: 0;
  }

  article.left nav {
    left: 0;
  }

  article:not(.left) nav {
    right: 0;
  }

  nav.open {
    display: block;
    border: 1px solid var(--secondary-light-color);
    padding-top: 30px;
    background-color: #f7f7f7;
    color: var(--primary-xx-dark-color);
    border-radius: 15px;
  }
</style>
